import { useState } from 'react'
import { Outlet } from 'react-router'
import { Footer } from '#app/components/footer.tsx'
import { Navbar } from '#app/components/navbar.tsx'

export default function MarketingLayout() {
	const [bannerVisible, setBannerVisible] = useState(false)

	return (
		<div className="flex min-h-screen flex-col">
			{bannerVisible && (
				<div className="relative bg-black px-4 py-2 text-center text-sm text-white">
					<span className="font-medium">🎉 We just raised $3M!</span>
					<span className="ml-2 opacity-90">
						Building the future of AI pharmacovigilance
					</span>
					<button
						onClick={() => setBannerVisible(false)}
						className="absolute top-1/2 right-4 -translate-y-1/2 transform text-lg leading-none text-white opacity-70 hover:opacity-100"
						aria-label="Close banner"
					>
						×
					</button>
				</div>
			)}
			<div className="flex min-h-0 flex-1 flex-col">
				<Navbar />
				<main className="min-h-0 flex-1">
					<Outlet />
				</main>
				<Footer />
			</div>
		</div>
	)
}
